import MyRatingAndStat from './MyRatingAndStat';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import groupsSearchCollector from '../../../../../components/Hocs/GroupsSearchNewCollector';

export default ColumnsContent(groupsSearchCollector(MyRatingAndStat));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyRatingAndStat/index.js